import { connect } from 'react-redux'
import { toggleDisclaimer } from '../../../actions/layout'

const DisclaimersButtonContainer = connect(null, dispatch => ({
  onClick: () => dispatch(toggleDisclaimer()),
}))

export default DisclaimersButtonContainer
